<template>
  <div class="legal">
    <h1>This is a legal page</h1>
  </div>
</template>

<script>
export default {
  name: 'legal'
}
</script>
